import { render, staticRenderFns } from "./PDFResults.vue?vue&type=template&id=63e71d12"
import script from "./PDFResults.vue?vue&type=script&lang=js"
export * from "./PDFResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports